import { createFileRoute } from '@tanstack/react-router'
import { GlossaryPage, glossaryHead } from '@/components/glossary-page'

const data = {
  term: 'Heartbeat Monitoring',
  slug: 'heartbeat-monitoring',
  definition: `Heartbeat monitoring is a passive monitoring approach where your service sends periodic signals (heartbeats) to the monitoring platform. If the heartbeats stop arriving, the monitor triggers an alert.

This is the reverse of active monitoring, where the monitoring platform sends requests to your service. With heartbeat monitoring, your service is the one initiating communication on a schedule — typically every minute, every 5 minutes, or every hour.

Heartbeat monitoring is ideal for cron jobs, background workers, scheduled tasks, and batch processes — anything that runs on a schedule and should complete within a known time window.`,
  whyItMatters: `Some systems cannot be monitored with traditional HTTP checks. A nightly database backup, a weekly report generator, or a queue worker do not have public endpoints to ping. Heartbeat monitoring covers these blind spots.

If your cron job silently fails — whether from a crashed server, a full disk, or a code error — heartbeat monitoring detects the missing signal and alerts you. Without it, you might not notice until the data is stale or a customer reports a problem.`,
  howUptrackHelps: `Uptrack supports cron monitoring, where your scheduled jobs send a ping to a unique Uptrack URL when they complete. If the ping does not arrive within the expected window, Uptrack creates an incident and alerts your team.

Setup takes seconds — add a single curl command to the end of your cron job or scheduled task. Uptrack handles the rest.`,
  relatedTerms: [
    { name: 'Synthetic Monitoring', href: '/glossary/synthetic-monitoring' },
    { name: 'Uptime', href: '/glossary/uptime' },
    { name: 'MTTD', href: '/glossary/mttd' },
    { name: 'Incident Management', href: '/glossary/incident-management' },
  ],
}

export const Route = createFileRoute('/_site/glossary/heartbeat-monitoring')({
  component: () => <GlossaryPage data={data} />,
  head: () => glossaryHead(data),
})
